"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Country;
(function (Country) {
    Country["NL"] = "NL";
    Country["BE"] = "BE";
})(Country = exports.Country || (exports.Country = {}));
var Roles;
(function (Roles) {
    Roles["DRIVER"] = "driver";
    Roles["CUSTOMER_SERVICE"] = "customer-service";
    Roles["SUBCO"] = "subco";
    Roles["PLANNER"] = "planner";
})(Roles = exports.Roles || (exports.Roles = {}));
var FREEZER_LOG_NEXT_STEP;
(function (FREEZER_LOG_NEXT_STEP) {
    FREEZER_LOG_NEXT_STEP["BACK_INTO_DELIVERY"] = "Back into delivery";
    FREEZER_LOG_NEXT_STEP["BACK_TO_TRUNKRS"] = "Back to Trunkrs";
})(FREEZER_LOG_NEXT_STEP = exports.FREEZER_LOG_NEXT_STEP || (exports.FREEZER_LOG_NEXT_STEP = {}));
